const schoolActionPrefix = '@school/';

/* List of Redux constants */
export const SCHOOL_SET_LOADING = `${schoolActionPrefix}set-loading`;
export const SCHOOL_SET_PROFILE = `${schoolActionPrefix}set-profile`;
export const SCHOOL_SET_QUESTIONS = `${schoolActionPrefix}set-questions`;
export const SCHOOL_SET_SETTINGS = `${schoolActionPrefix}set-settings`;
export const SCHOOL_SET_USERS = `${schoolActionPrefix}set-users`;
export const SCHOOL_SET_VACANCIES = `${schoolActionPrefix}set-vacancies`;
export const SCHOOL_SET_VACANCIES_STATUS_STATS = `${schoolActionPrefix}set-vacancies-status-stats`;
export const SCHOOL_RESET_PROFILE = `${schoolActionPrefix}reset-profile`;
export const SCHOOL_RESET_QUESTIONS = `${schoolActionPrefix}reset-questions`;
export const SCHOOL_RESET_SETTINGS = `${schoolActionPrefix}reset-settings`;
export const SCHOOL_RESET_USERS = `${schoolActionPrefix}reset-users`;
export const SCHOOL_RESET_VACANCIES = `${schoolActionPrefix}reset-vacancies`;
export const SCHOOL_RESET_PUBLIC_VACANCIES = `${schoolActionPrefix}reset-public-vacancies`;
export const SCHOOL_SET_PUBLIC_PROFILE = `${schoolActionPrefix}set-public-details`;
export const SCHOOL_SET_PUBLIC_VACANCIES = `${schoolActionPrefix}set-public-vacancies`;
export const SCHOOL_SET_PUBLIC_VACANCY_DETAILS_LOADING = `${schoolActionPrefix}set-public-vacancy-details-loading`;
export const SCHOOL_SET_PUBLIC_VACANCY_DETAILS = `${schoolActionPrefix}set-public-vacancy-details`;
export const SCHOOL_RESET_PUBLIC_VACANCY_STATE = `${schoolActionPrefix}reset-public-vacancy-state`;
export const SCHOOL_SET_PUBLIC_VACANCY_DETAILS_FAILED_CODE = `${schoolActionPrefix}set-public-vacancy-details-failed-code`;
export const SCHOOL_SET_VACANCIES_QUERY_PARAMS = `${schoolActionPrefix}set-vacancies-query-params`;
export const SCHOOL_SET_PRIOR_CANDIDATES_LOADING = `${schoolActionPrefix}set-prior-candidates-loading`;
export const SCHOOL_SET_PRIOR_CANDIDATES = `${schoolActionPrefix}set-prior-candidates`;
export const SCHOOL_RESET_PRIOR_CANDIDATES = `${schoolActionPrefix}reset-prior-candidates`;
export const SCHOOL_SET_QUESTION_ADDING = `${schoolActionPrefix}set-question-adding`;
export const SCHOOL_SET_QUESTION_DELETING = `${schoolActionPrefix}set-question-deleting`;
export const SCHOOL_VACANCY_SET_PRIOR_CANDIDATES_QUERY_PARAMS = `${schoolActionPrefix}set-prior-candidates-filter-query`;
export const SCHOOL_SET_SETTINGS_LOADING = `${schoolActionPrefix}set-settings-loading`;
export const SCHOOL_SET_SETTINGS_UPDATING = `${schoolActionPrefix}set-settings-updating`;
export const SCHOOL_SET_SCHOOL_PUBLIC_PROFILE_FAILED_CODE = `${schoolActionPrefix}set-school-public-profile-failed-code`;
export const SCHOOL_SET_SCHOOL_PUBLIC_VACANCIES_FAILED_CODE = `${schoolActionPrefix}set-school-public-vacancies-failed-code`;

/* List of Sagas constants */
export const SCHOOL_GET_PROFILE = `${schoolActionPrefix}get-profile`;
export const SCHOOL_GET_QUESTIONS = `${schoolActionPrefix}get-questions`;
export const SCHOOL_GET_SETTINGS = `${schoolActionPrefix}get-settings`;
export const SCHOOL_GET_USERS = `${schoolActionPrefix}get-users`;
export const SCHOOL_GET_VACANCIES = `${schoolActionPrefix}get-vacancies`;
export const SCHOOL_ADD_QUESTION = `${schoolActionPrefix}add-question`;
export const SCHOOL_REMOVE_QUESTION = `${schoolActionPrefix}remove-question`;
export const SCHOOL_GET_PUBLIC_PROFILE = `${schoolActionPrefix}get-public-details`;
export const SCHOOL_GET_PUBLIC_VACANCIES = `${schoolActionPrefix}get-public-vacancies`;
export const SCHOOL_FETCH_PUBLIC_VACANCY_DETAILS = `${schoolActionPrefix}fetch-public-vacancy-details`;
export const SCHOOL_GET_PRIOR_CANDIDATES = `${schoolActionPrefix}get-prior-candidates`;
export const SCHOOL_UPDATE_SETTINGS = `${schoolActionPrefix}update-settings`;


// WEBPACK FOOTER //
// ./src/actions/school/types.js